import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", null, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        toast.success(`Signed in as ${data.name || data.email}`);
        nav("/dashboard", { replace: true, state: { user: data } });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="container-bl py-24 text-center" data-testid="page-auth-callback">
      <div className="animate-pulse text-[#AEB9C9]">Finishing sign in…</div>
    </div>
  );
}
